module.exports = __webpack_public_path__ + "static/7-61419a6843b1e14d9d3941dd7a06efca.png";